const item = "_item_8j2l6_17";
const interactive = "_interactive_8j2l6_35";
const icon = "_icon_8j2l6_43";
const label = "_label_8j2l6_52";
const disabled = "_disabled_8j2l6_118";
const styles = {
  item,
  interactive,
  "no-label": "_no-label_8j2l6_39",
  icon,
  label,
  "nav-hint": "_nav-hint_8j2l6_59",
  disabled
};
export {
  styles as default,
  disabled,
  icon,
  interactive,
  item,
  label
};
//# sourceMappingURL=MenuItem.module.css.js.map
